<template>
  <h1>
    <router-link to="/" class="home-link">Paper Boat</router-link>
  </h1>
  <h3>Pour it out, then set it free.</h3>
  <div id="app">
    <router-view/>
  </div>
  <footer class="site-footer">
    <a href="https://gobeyonddev.com" target="_blank" rel="noopener noreferrer">
      <img src="@/assets/GoBeyond-footer-logo.svg" alt="GoBeyond logo" class="footer-logo" />
    </a>
  </footer>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Quicksand, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  width: 80vw;
  margin: 0 auto 0 auto;
}
h3 {
  font-family: 'Parisienne', cursive;
  font-weight: 400;
  font-size: 2.1rem;
  margin-top: 0;
  margin-bottom: 20px;
  color: #444;
  text-align: center;
  opacity: 0.85;
 }
h1 {
  font-family: 'Fredericka the Great', cursive, serif;
  font-size: 2.75rem;
  letter-spacing: 4px;
  margin-bottom: 10px;
  color: #444;
  font-weight: normal;
  opacity: 0.85;
  text-align: center;
}
.home-link {
  color: inherit;
  text-decoration: none;
  cursor: pointer;
  transition: color 0.2s;
}
.home-link:hover {
  color: #ff9800;
}
@media (max-width: 600px) {
  #app {
    margin-top:20px;
  }
  h3 {
    margin-bottom: 10px;
  }
  h1 {
    margin-top: 90px;
  }
}
.site-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px 0 16px;
  margin-top: 40px;
}
.footer-logo {
  height: 84px;
  width: auto;
  opacity: 0.75;
}
</style>
